import React, { useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useApp } from "@/store";

export const ReportButton = ({ listingId, userId, testPrefix = "report" }) => {
  const { t, user } = useApp();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const label = listingId ? t("report_listing") : t("report_user");

  const submit = async () => {
    if (reason.trim().length < 5) { toast.error(t("report_min")); return; }
    setBusy(true);
    try {
      await api.post("/reports", { listing_id: listingId || null, user_id: userId || null, reason, reporter_email: user ? null : (email || null) });
      toast.success(t("report_sent")); setOpen(false); setReason(""); setEmail("");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || t("report_failed")); }
    finally { setBusy(false); }
  };

  if (!open) return (
    <button data-testid={`${testPrefix}-btn`} onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 text-sm font-semibold text-gray-400 transition-colors hover:text-[#FF3B30]"><Flag size={14} /> {label}</button>
  );
  return (
    <div className="rounded-xl border border-gray-200 p-3" data-testid={`${testPrefix}-form`}>
      <textarea data-testid={`${testPrefix}-reason`} value={reason} onChange={(e) => setReason(e.target.value)} placeholder={t("report_placeholder")} rows={2} className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm outline-none focus:border-[#FF3B30]" />
      {!user && <input data-testid={`${testPrefix}-email`} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("report_email_optional")} className="mt-2 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm outline-none focus:border-[#FF3B30]" />}
      <div className="mt-2 flex gap-2">
        <button data-testid={`${testPrefix}-submit`} disabled={busy} onClick={submit} className="rounded-full bg-[#FF3B30] px-4 py-1.5 text-sm font-bold text-white disabled:opacity-60">{t("report_submit")}</button>
        <button data-testid={`${testPrefix}-cancel`} onClick={() => setOpen(false)} className="rounded-full border border-gray-300 px-4 py-1.5 text-sm font-bold text-gray-600">{t("cancel")}</button>
      </div>
    </div>
  );
};
